<template>
  <div>
    <div class='h-olap-search-area'>
      <ejs-textbox :placeholder='searchHolder' v-model='keywords'></ejs-textbox>
      <ejs-button :isPrimary='true' @click.native='queryByNum' cssClass='olap-search-button'>{{$t('TS.ts_search')}}</ejs-button>
    </div>
    <div class='h100-47 h-scroll'>
      <ejs-grid ref='grid' height='calc(100vh - 520px)' :dataSource='data' :allowSorting='true' :allowReordering='true' :allowResizing='true'>
        <e-columns>
          <e-column field='isCaller' minWidth='10' :headerText='$t("TS.ts_digital_isCaller")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='isCallerFormat'></e-column>
          <e-column field='callType' minWidth='10' :headerText='$t("TS.ts_digital_callType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='callTypeFormat'></e-column>
          <!--<e-column field='groupNum' minWidth='10' :headerText='$t("TS.ts_call_groupNum")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='groupNumFormat'></e-column>-->
          <!--<e-column field='callingType' minWidth='10' :headerText='$t("TS.ts_call_callingType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='callingTypeFormat'></e-column>-->
          <e-column field='callingAddress' minWidth='10' :headerText='$t("TS.ts_call_callingAddress")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <!--<e-column field='calledType' minWidth='10' :headerText='$t("TS.ts_call_calledType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='calledTypeFormat'></e-column>-->
          <e-column field='calledAddress' minWidth='10' :headerText='$t("TS.ts_call_calledAddress")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='sendTime' minWidth='10' :headerText='$t("TS.sendTimeHeader")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' type='dateTime' format='yyyy-MM-dd HH:mm:ss'></e-column>
          <e-column field='acceptTime' minWidth='10' :headerText='$t("TS.acceptTimeHeader")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' type='dateTime' format='yyyy-MM-dd HH:mm:ss'></e-column>
          <e-column field='dataLen' minWidth='10' :headerText='$t("TS.dataLenHeader")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='callResult' minWidth='10' :headerText='$t("TS.sendResult")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='callResultFormat'></e-column>
          <e-column field='callCause' minWidth='10' :headerText='$t("TS.ts_digital_callCause")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column :headerText='$t("TS.operating")' textAlign='Center' width='8%' clipMode='EllipsisWithTooltip' :template='realTemplate'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='getListData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    </div>
    <CustomDialog ref='singleCalledCountPage' :element='dialog.element.eleCalledSingle' :styles='dialog.stylesCalledDetail' :messages='dialog.messages.single'>
      <template v-slot:dialog-content>
        <DigitalCalledDetailGrid ref='calledDetailGrid'></DigitalCalledDetailGrid>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
import Global from '../Global';
import CustomDialog from '../../common/CustomDialog';
import DigitalCalledDetailGrid from './DigitalCalledDetailGrid';
import { Reorder, Resize, Sort } from '@syncfusion/ej2-vue-grids';
import DigitalDetailColumnButton from './DigitalDetailColumnButton';
export default {
  name: 'DigitalDetailGrid',
  components: {
    CustomDialog,
    DigitalCalledDetailGrid
  },
  data() {
    return {
      olapUrl: Global.olapUrl,
      searchHolder: this.$t('TS.searchByNumHolder'),
      keywords: '',
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      queryConditions: {},
      data: [],
      realTemplate(args) {
        return {
          template: DigitalDetailColumnButton
        };
      },
      dialog: {
        stylesCalledDetail: {
          width: '95%',
          height: '78%',
          visible: false,
          zIndex: 1200,
          model: true
        },
        element: {
          eleCalledSingle: {
            target: this.$refs.calledCountChart,
            refName: 'eleSingle',
            buttonGroup: [
              { click: this.closeCalledSinglePage, buttonModel: { content: this.$t('TS.ts_cancell') } }
            ],
            title: this.$t('TS.ts_callee_detail'),
            isClose: true
          }
        },
        messages: {
          single: {
            title: this.$t('TS.ts_callee_detail')
          }
        }
      }
    };
  },
  provide: {
    grid: [Reorder, Resize, Sort]
  },
  methods: {
    callTypeFormat(grid, data) {
      if (data.callType !== null && data.callType !== '') {
        return this.$t(`TS.msgCallType_${data.callType}`);
      } else {
        return '';
      }
    },
    groupNumFormat(grid, data) {
      if (data.groupNum !== null && data.groupNum !== '') {
        return data.groupNum;
      } else {
        return '--';
      }
    },
    isCallerFormat(grid, data) {
      if (data.isCaller !== null && data.isCaller !== '') {
        return this.$t(`TS.isCallerStatus_${data.isCaller}`);
      } else {
        return '';
      }

    },
    callingTypeFormat(grid, data) {
      if (data.callingType !== null && data.callingType !== '') {
        return this.$t(`TS.callingTypeStatus_${data.callingType}`);
      } else {
        return '';
      }
    },
    calledTypeFormat(grid, data) {
      if (data.calledType !== null && data.calledType !== '') {
        return this.$t(`TS.callingTypeStatus_${data.calledType}`);
      } else {
        return '';
      }
    },
    callResultFormat(grid, data) {
      if (data.callResult !== null && data.callResult !== '') {
        return this.$t(`TS.callCauseStatus_${data.callResult}`);
      } else {
        return '';
      }
    },
    closeCalledSinglePage() {
      this.$refs.singleCalledCountPage.clear();
      this.$refs.singleCalledCountPage.close();
    },
    queryByNum(){
      this.getListData();
    },
    setQueryParams(params) {
      this.page.pageSize = 10;
      this.queryConditions = params;
      this.keywords = '';
      this.getListData();
    },
    getListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      const params = This.getParams();
      params.pageNo = parseInt(This.page.pageNo, 10);
      params.pageSize =  parseInt(This.page.pageSize, 10);
      params.num = This.keywords;
      params.isCaller = 1;
      This.$loading.showLoadding(this.$t('MML.loadingTip'));
      This.$axios.post(`${Global.olapUrl}/lte/ems/olap/digital/detailStatistics`, params).then((response) => {
        if (response && response.status === 200) {
          const result = response.data;
          This.page.totalCount = result.total;
          This.data = result.list;
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
        This.$loading.hideLoadding();
      }).catch(err => {
        This.$loading.hideLoadding();
      });
    },
    getParams() {
      const {timeInterval,startdate,enddate,neId,xAxisValue,detailType} = this.queryConditions;
      const [beginHourAndMin,endHourAndMin] = xAxisValue.split('~');
      let startDate = `${startdate}`;
      let endDate = `${enddate}`;
      // 如果是天 需要手动赋00:00 xAxisValue表示的是天和时
      if (timeInterval === 2){
        const year = startdate.split('-')[0];
        startDate = `${year}-${beginHourAndMin} 00:00:00`;
        endDate = `${year}-${beginHourAndMin} 23:59:59`;
      } else {
        startDate = `${startDate} ${beginHourAndMin}:00`;
        if(("23:45" === beginHourAndMin || "23:00" === beginHourAndMin) && "00:00" === endHourAndMin){
          endDate = `${endDate} 23:59:59`;
        } else {
          endDate = `${endDate} ${endHourAndMin}:00`;
        }
      }
      const beginTime = new Date(startDate);
      const endTime = new Date(endDate);
      return {beginTime,endTime,neId,detailType}
    }
  },
  mounted() {
    bus.$on('digitalCalledDetail', (params) => {
      this.$refs.calledDetailGrid.setQueryParams(params);
      this.$refs.singleCalledCountPage.show();
    });
  },
  beforeDestroy() {
    bus.$off('digitalCalledDetail');
  }
};
</script>

<style scoped>


  .h-olap-search-area{
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 15px
  }
  .olap-search-button{
    margin-left:10px
  }
</style>
